export const WS_ROOM_PROTOBUF_JSON = {
  nested: {
    chat: {
      nested: {
        ChatMessage: {
          fields: {
            user: { type: 'string', id: 1 },
            room_id: { type: 'int32', id: 2 },
            content: { type: 'string', id: 3 },
            timestamp: { type: 'int64', id: 4 },
            type: { type: 'MessageType', id: 5 },
            to: { type: 'string', id: 6 }
          }
        },
        MessageType: {
          values: {
            UNKNOWN: 0,
            SYSTEM: 1,
            USER_TEXT: 2,
            QUERY_COUNT: 3,
            ROOM_COUNT: 4,
            DIRECT_MESSAGE: 5,
            ONLINE_USERS: 6,
            PLAYER_MOVE: 7,
            MAP_STATE: 8,
            POKER_SIT: 9,
            POKER_STAND: 10,
            POKER_READY: 11,
            POKER_ACTION: 12,
            POKER_STATE: 13,
            POKER_PRIVATE: 14,
            POKER_SPECTATE: 15,
            POKER_LEAVE: 16,
            POKER_ROOM_TEXT: 17
          }
        },
        AudioChunk: {
          fields: {
            sender: { type: 'string', id: 1 },
            to: { type: 'string', id: 2 },
            data: { type: 'bytes', id: 3 },
            timestamp: { type: 'int64', id: 4 },
            mime_type: { type: 'string', id: 5 }
          }
        },
        WsEnvelope: {
          fields: {
            chat: { type: 'ChatMessage', id: 1 },
            audio: { type: 'AudioChunk', id: 2 }
          }
        }
      }
    }
  }
}
